import React from 'react'
import Box from '@mui/material/Box'

import type {Theme} from '@mui/material'

const CentralDivider = () => (
  <Box
    sx={{
      position: 'absolute',
      width: '2px',
      height: '100%',
      mt: 18,
      background: (theme: Theme) =>
        `linear-gradient(180deg, #FFFFFF -2.37%, ${theme.palette.primary.main} 47.79%, #FFFFFF 98.41%)`,
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: -2,
    }}
  />
)

export default CentralDivider
